import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormComp05  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fechaDesde: null,
            fechaHasta: null,
            proveedor_sel: null
        };

        this.impDiarioCompras = this.impDiarioCompras.bind(this);
        this.limpiar = this.limpiar.bind(this);
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0605')
         ])
        .then(() => {
            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('06')

            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0605');
    }

    //Validacion Año
    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');

        //Evaluacion Año
        if(parseInt(fechaPart[2],10)<=parseInt(fechaPartProceso[2],10)){
            respuesta = true;
        }else{
            respuesta = false;
        }
        return respuesta;
    }

    impDiarioCompras(){
        var continuar = true;
        var error = "";
        var errorAnio = false;

        let fechaProceso = getFechaProcesoPorModulo('06')

        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaHasta)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        }

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar===true){
            var parametros = ""
            parametros = '&rpt=18&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)

            if(this.state.proveedor_sel!==null){
                parametros = parametros+'&param3='+this.state.proveedor_sel.value
            }
            
            visualizarReporteEnPdf(parametros);
        }else{
            alert(error);
        }
    }

    limpiar(){

        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('06')
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})

        this.setState({
            proveedor_sel: null
        })
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Diario de Compras</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-md-6'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({proveedor_sel: value!==null?value:null})}}/>
                        </ContainerCol>      
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>                                     
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={20}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impDiarioCompras}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>
                                <button type="button" className='btn btn-sm' disabled={this.state.cobro} onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormComp05);